<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Configuration des services</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addService">Ajouter un service</v-btn>
    </v-toolbar>
    <v-card elevation="0">
      <v-card-text>
        <v-data-table :headers="headers" :items="services" :items-per-page="20" class="elevation-0">
          <template v-slot:item.type_id="{item}">{{typeLabel(item.type_id)}}</template>
          <template v-slot:item.status="{item}">
            <v-chip
              dark
              :color="item.status==1 ? 'green': 'grey'"
            >{{item.status==1 ? 'Visible': 'Caché'}}</v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="up(item)">mdi-arrow-up</v-icon>
            <v-icon small class="mr-2" @click="down(item)">mdi-arrow-down</v-icon>
            <v-icon small class="mr-2" @click="edit(item)">mdi-pencil</v-icon>
            <v-icon small @click="desactivate(item)" v-if="item.status==1">mdi-eye-off</v-icon>
            <v-icon small @click="activate(item)" v-else>mdi-eye</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="serviceForm" persistent max-width="980px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Ajouter un service</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col>
                  <v-select
                    label="Type de service"
                    v-model="service.type_id"
                    :items="types"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="service.name" label="Nom du service" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancel()">Annuler</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save()">Sauver</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      headers: [
        {
          text: "Type",
          align: "left",
          sortable: false,
          value: "type_id"
        },
        { text: "Nom", value: "name" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "action", sortable: false }
      ],
      serviceForm: false,
      valid: false,
      service: {
        type_id: 0,
        name: "",
        status: 0
      }
    };
  },
  computed: {
    ...mapState("services", {
      services: state => state.list,
      types: state => state.types
    })
  },
  mounted: function() {
    this.getServices();
  },
  methods: {
    typeLabel(type) {
      if (type == "rdv") {
        return "Prise de rendez-vous";
      }
      if (type == "file") {
        return "Traitement de fichier";
      }
      if (type == "offer") {
        return "Demande d'offre personalisé";
      }
      return "Autre";
    },
    getServices() {
      this.$store.dispatch("services/list");
    },
    activate(service) {
      this.$store.dispatch("services/activate", service.id);
    },
    desactivate(service) {
      this.$store.dispatch("services/desactivate", service.id);
    },
    up(service) {
      this.$store.dispatch("services/up", service.id);
    },
    down(service) {
      this.$store.dispatch("services/down", service.id);
    },
    edit(service) {
      this.$router.push("/services/view/" + service.id);
    },
    addService() {
      this.serviceForm = true;
    },
    resetForm() {
      (this.service.type_id = null), (this.service.name = null);
    },
    cancel() {
      this.resetForm();
      this.serviceForm = false;
    },
    save() {
      this.$store.dispatch("services/create", this.service).then(() => {
        this.resetForm();
        this.serviceForm = false;
        this.getServices();
      });
    }
  }
};
</script>

<style>
</style>